import axiosInstance from '../axiosConfig';

export default {
  async getCart(payload) {
    const response = await axiosInstance.post('EcomSelCarrito', payload);
    return response.data;
  },
  async addToCart(payload) {
    const response = await axiosInstance.post('EcomCarrito', payload);
    return response.data;
  },
  async updateCart(payload) {
    const response = await axiosInstance.put('EcomCarrito', payload);
    return response.data;
  },
};
